import { SharedModule } from "./../../app/shared.module";
import { LoginProvider } from "../../providers/login/login";
import { NgModule } from "@angular/core";
import { LoginPage } from "./login";
import { RemoteServicesProvider } from "providers/remote-services/remote-services";
import { LocalstorageProvider } from "providers/localstorage/localstorage";
import { DomainStorageProvider } from "providers/domain-storage/domain-storage";
import { GeolocalizationProvider } from "providers/geolocalization/geolocalization";
import { RootStore } from "stores/root-store";


@NgModule({
	declarations: [LoginPage],
	imports: [
		SharedModule
	],
	exports: [LoginPage],
	providers: [
		LoginProvider,
		RemoteServicesProvider,
		LocalstorageProvider,
		RemoteServicesProvider,
		DomainStorageProvider,
		GeolocalizationProvider,
		RootStore
	]
})
export class LoginPageModule { }
